import { render, staticRenderFns } from "./UserMenuV2.vue?vue&type=template&id=6a1904da&"
import script from "./UserMenuV2.vue?vue&type=script&lang=js&"
export * from "./UserMenuV2.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports